export type FilesNamespace = 'attachments' | 'sowe' | 'assetPhotos';

const MAX_FILE_SIZE_BYTES = 50 * 1024 * 1024;

export const files = {
  isValidSize: (size: number) => size <= MAX_FILE_SIZE_BYTES,
  isValidType: (ns: FilesNamespace, type: string) => (nsMap[ns] ?? []).includes(type),
  getAllowedMimeTypes: (ns: FilesNamespace): string[] => nsMap[ns] ?? [],
  getFileInputAccept: (ns: FilesNamespace) => (nsMap[ns] ?? []).join(', '),
};

const attachmentsAllowedMimeTypes = [
  'image/heic',
  'image/heif',
  'image/jpeg',
  'image/png',
  'image/tiff',
  'text/csv',
  'text/plain',
  'application/pdf',
  'application/msword',
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  'application/rtf',
  'application/vnd.apple.keynote',
  'application/vnd.oasis.opendocument.text',
  'application/vnd.ms-powerpoint',
  'application/vnd.openxmlformats-officedocument.presentationml.presentation',
  'application/vnd.ms-powerpoint.slideshow.macroEnabled.12',
  'application/vnd.openxmlformats-officedocument.presentationml.slideshow',
  'application/vnd.ms-excel',
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
];

const soweAllowedMimTypes = [
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  'application/msword',
  'application/vnd.apple.pages',
  'application/pdf',
  'image/png',
  'image/jpg',
  'image/jpeg',
  'text/plain',
];

const assetPhotoAllowedMimeTypes = ['image/heic', 'image/jpeg', 'image/jpg', 'image/png'];

const nsMap: Record<FilesNamespace, string[]> = {
  attachments: attachmentsAllowedMimeTypes,
  sowe: soweAllowedMimTypes,
  assetPhotos: assetPhotoAllowedMimeTypes,
};
